import { ThemeDefinition } from 'vuetify';

export const physicalEducation: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#89CAAD',
    'on-subject-original': '#FFFFFF',
    subject: '#3A8262',
    'on-subject': '#FFFFFF',
    primary: '#2C634A',
    'on-primary': '#FFFFFF',
    'primary-container': '#CAE7DA',
    'on-primary-container': '#132A20',
    secondary: '#455E53',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D3DED9',
    'on-secondary-container': '#1A231F',
    surface: '#F7FCFA',
    'on-surface': '#1D201F',
    'on-surface-medium': '#49504D',
    'on-surface-low': '#949E9A',
    outline: '#798680',
    'outline-variant': '#C9CFCC',
    'inverse-surface': '#244235',
    'inverse-on-surface': '#EEF6F3',
    'inverse-primary': '#B9DFCE',
    'surface-dim': '#C2EBD8',
    'surface-bright': '#FBFEFD',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F0FAF5',
    'surface-container': '#E8F7F1',
    'surface-container-high': '#D9F2E7',
    'surface-container-highest': '#D1F0E2',
  },
};

export const physicalEducationDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#89CAAD',
    'on-subject-original': '#F7FCFA',
    subject: '#8ECCB0',
    'on-subject': '#132A20',
    primary: '#B9DFCE',
    'on-primary': '#132A20',
    'primary-container': '#295B45',
    'on-primary-container': '#EDF7F3',
    secondary: '#C4D4CD',
    'on-secondary': '#1A231F',
    'secondary-container': '#3F554B',
    'on-secondary-container': '#F0F4F2',
    surface: '#101815',
    'on-surface': '#F2F3F2',
    'on-surface-medium': '#C9CFCC',
    'on-surface-low': '#798680',
    outline: '#949E99',
    'outline-variant': '#616B66',
    'inverse-surface': '#DEEDE6',
    'inverse-on-surface': '#152820',
    'inverse-primary': '#204635',
    'surface-dim': '#0E1512',
    'surface-bright': '#2F463C',
    'surface-container-lowest': '#0C1210',
    'surface-container-low': '#141F1A',
    'surface-container': '#1B2822',
    'surface-container-high': '#23342C',
    'surface-container-highest': '#2D4339',
  },
};
